import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import Layout from './components/Layout/Layout';
import { TranslationWrapper } from './components/common';

// Import des pages
import Home from './pages/Home';
import LearnAbout from './pages/LearnAbout';
import LearnAboutEvisaB2 from './pages/LearnAboutEvisaB2';
import VisaOptions from './pages/VisaOptions';
import ApplyForAnEtail1 from './pages/ApplyForAnEtail1';
import ApplyForAnEtail2 from './pages/ApplyForAnEtail2';
import GetHelp from './pages/GetHelp';
import NotFound from './pages/NotFound';
import Search from './pages/Search';
import ApplyForAnEvisa1 from './pages/ApplyForAnEvisa1';
import ApplyForAnEvisa2 from './pages/ApplyForAnEvisa2';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TranslationWrapper>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/learn-about" element={<LearnAbout />} />
              <Route path="/learn-about-evisa-b2" element={<LearnAboutEvisaB2 />} />
              <Route path="/visa-option" element={<VisaOptions />} />
              <Route path="/apply-for-an-eta-il-1" element={<ApplyForAnEtail1 />} />
              <Route path="/apply-for-an-eta-il-2" element={<ApplyForAnEtail2 />} />
              <Route path="/apply-for-an-evisa-b2-1" element={<ApplyForAnEvisa1 />} />
              <Route path="/apply-for-an-evisa-b2-2" element={<ApplyForAnEvisa2 />} />
              <Route path="/get-help" element={<GetHelp />} />
              <Route path="/search" element={<Search />} />
            </Routes>
          </Layout>
        </Router>
      </TranslationWrapper>
    </ThemeProvider>
  );
}

export default App;
